import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    spacing: {
      marginTop: 80,
    },
    text: {
      color: theme.palette.text.main,
    },
    storesContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 20,
    },
    image: {
      height: 40,
      "&:first-child": {
        marginRight: 20,
      },
    },
  }),
  { name: "AppsPromo" },
);
